<template>
  <div
    class="w-full h-[300px] flex items-center justify-center flex-col border border-gray-200 bg-white rounded"
  >
    <div class="flex flex-col gap-[12px] justify-center items-center">
      <h2 class="font-medium text-2xl text-primary-600">
        אין עכשיו מכירות פתוחות
      </h2>
      <p class="text-lg font-medium text-grays-900">
        <template v-if="salesData.days_till_next_sale > 0">
          {{
            " המכירה הבאה " +
            salesData.next_sale_name +
            ` תפתח בעוד ${salesData.days_till_next_sale} ימים`
          }}
        </template>
        <template v-else>
          המכירה הבאה {{ salesData.next_sale_name }} תפתח יותר מאוחר היום
        </template>
      </p>
    </div>
    <button-primary
      v-if="!isRemindSet"
      :onclick="goToNotificationSection"
      class="relative top-[56px]"
    >
      תתזכרו אותנו כשהמכירה נפתחת
    </button-primary>
    <div v-else class="text-primary-900 mt-[56px] flex items-center gap-[6px]">
      <span class="material-symbols-rounded text-[16px]">notifications</span>
      <span>כמו שביקשתם, נתזכר אתכם כשהמכירה תפתח.</span>
      <button class="h-[16px]" @click="goToNotificationSection">
        <span class="material-symbols-rounded text-[16px]">edit</span>
      </button>
    </div>
  </div>
</template>

<script>
import ButtonPrimary from "@/components/Global/ButtonPrimary.vue";

export default {
  name: "card-sale-missing",
  components: { ButtonPrimary },
  data() {
    return {
      isRemindSet: false,
    };
  },
  props: {
    salesData: {
      type: Object,
      required: true,
    },
  },
  methods: {
    goToNotificationSection() {
      this.$router.push("/profile");
      setTimeout(() => {
        window.scrollTo({
          top: document.body.scrollHeight,
          behavior: "smooth",
        });
      }, 100);
    },
    remindCheck() {
      const user = JSON.parse(localStorage.getItem("user") || "{}");
      if (Object.keys(user).length === 0) {
        return;
      }
      this.isRemindSet =
        user &&
        (user.remind_before_closing_sale ||
          user.remind_on_day_of_pickup ||
          user.remind_on_opening_new_sale);
    },
  },
  mounted() {
    this.remindCheck();
  },
};
</script>

<style>
</style>